import "../../menu.css"
import {Dishes} from "../../../../DataBase/data";
import Modal from "../modal/modal";
import {useState} from "react";


const Fresh = ({dishes,s,idx}) => {
    const [isOpen, setIsOpen] = useState(false);
    const [currItemIdx, setCurrItemIdx] = useState(0);

    const toggle = (itemId) => {
        setCurrItemIdx(itemId);
        setIsOpen(p => !p);
        console.log(itemId)
    }

    const nextButton = () => {
        if (currItemIdx !== 104) {
            setCurrItemIdx(currItemIdx + 1)
        }
    }

    const prevButton = () => {
        if (currItemIdx !== 0) {
            setCurrItemIdx(currItemIdx - 1)
        }
    }

    return (
        <>
            <h1 className="categoryName" id={'fresh'}>Фреш</h1>
            {
                dishes.filter((val) => {
                    if (s === '') {
                        return val
                    } else if (val.name.toUpperCase().includes(s.toUpperCase())) {
                        return val
                    }
                }).map((salads, index) => (
                    salads.category === "fresh" ? <div key={index} className={'menu_content_block_card'} onClick={() =>{
                        toggle(index)
                    }}>
                        <div key={index} className="menu_content_block_card_header">
                            <div className="menu_content_block_card_header_img">
                                <img src={salads.image} alt=""/></div>
                        </div>
                        <div className="menu_content_block_card_footer">
                            <div className="menu_content_block_card_footer_title">{salads.name}</div>
                            <div className="menu_content_block_card_footer_price">{salads.price}</div>
                        </div>
                    </div> : " "
                ))
            }
            <Modal isOpen={isOpen} next={nextButton} prev={prevButton} toggle={toggle} item={Dishes[currItemIdx]}/>
        </>
    )
}

export default Fresh
